import type { AppDispatch } from '@/store/store'
import type { AgentAssistantRequestParams } from '@/agent/chat_form/store/schemas'
import { fetchAndStoreUserFiles } from '@/user_files/files/utils/fetch-and-store-user-files'

/**
 * On conversation load, eagerly resolve the UserFile records for the attached user files and
 * writing samples referenced by the restored request params.
 *
 * The selected-files panel (SelectedFilesContent) is otherwise the only place these records are
 * loaded, and it only mounts when the panel is expanded. Without this, the collapsed files header
 * can't tell that an attached file has finished processing — it shows a spurious processing state
 * (and blocks submit) until the user expands the panel.
 *
 * Note: not `template_paths` — those are legacy GCS paths, not user_file ids. Fire-and-forget and
 * isolated: a failure here must never fail conversation loading.
 */
export function hydrateConversationUserFileRecords(requestParams: AgentAssistantRequestParams | null, dispatch: AppDispatch): void {
  if (!requestParams) return

  const userFileIds = [...(requestParams.user_files_rag?.user_file_ids ?? []), ...(requestParams.writing_sample_files?.user_file_ids ?? [])].filter(
    (id): id is string => Boolean(id)
  )

  if (userFileIds.length > 0) {
    fetchAndStoreUserFiles(userFileIds, dispatch).catch(() => undefined)
  }
}
